import React from "react";
import {ButtonIconRepairDetails} from "../../../../Components/Inputs";
import {isUnloanedRepair} from "../BraillerLoanManagement/braillerLoanManagementUtility";

interface BraillerHistoryRowProps {
    loanHistory: Record<string, any>;
    onShowRepairDetails?: (loanId: string, repairId: string) => void;
}

export const BraillerHistoryRow = ({loanHistory, onShowRepairDetails}: BraillerHistoryRowProps) => {
    const getStatusBadge = () => {
        if (loanHistory.isOverdue && !loanHistory.returnedDate) {
            return <span className="badge badge--error">Overdue ({loanHistory.daysOverdue} days)</span>;
        }
        if (loanHistory.returnedDate) {
            return <span className="badge badge--success">Returned</span>;
        }
        
        const statusText = loanHistory.status || "";
        
        if (statusText.toLowerCase().includes("repair")) {
            return <span className="badge badge--warning">{statusText}</span>;
        }
        if (statusText === "CheckedOut" || statusText === "3") {
            return <span className="badge badge--warning">Checked Out</span>;
        }
        
        return <span className="badge badge--info">{statusText}</span>;
    };

    const handleRepairDetailsClick = () => {
        if (loanHistory.loanId && onShowRepairDetails) {
            onShowRepairDetails(loanHistory.loanId, loanHistory.repairId);
        }
    };

    const statusText = (loanHistory.status || "").toLowerCase();
    const showRepairDetailsButton = loanHistory.loanId && 
        (statusText.includes("repair") || 
         statusText === "repairrequested" ||
         statusText === "checkedout" ||
         statusText === "readyforcheckout" ||
         statusText === "9" || 
         statusText === "10" ||
         statusText === "3" ||
         statusText === "1");

    const renderPatronInfo = () => {
        if (loanHistory.patronName) return loanHistory.patronName;
        if (loanHistory.studentName) return loanHistory.studentName;
        if (isUnloanedRepair(loanHistory)) return <em>Unloaned Repair</em>;
        return '-';
    };

    return (
        <tr data-testid={`loan-history-row-${loanHistory.loanId}`}>
            <td>{loanHistory.model}</td>
            <td>{loanHistory.catalogItemTitle}</td>
            <td>{loanHistory.serialNumber}</td>
            <td>{loanHistory.shippingLocationName}</td>
            <td>{renderPatronInfo()}</td>
            <td>{loanHistory.dateCreatedFormatted}</td>
            <td>{loanHistory.checkedOutDateFormatted}</td>
            <td>{loanHistory.returnedDateFormatted || "-"}</td>
            <td>{getStatusBadge()}</td>
            <td>
                {showRepairDetailsButton && (
                    <ButtonIconRepairDetails
                        id={`repair-details-${loanHistory.loanId}`}
                        inputDescription="View Print Details"
                        onClick={handleRepairDetailsClick}
                    />
                )}
            </td>
        </tr>
    );
};
